import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const networkTopologyFilterFormTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'NetworkTopology',
  key: 'NETWORK_TOPOLOGY',
  main: {
    metadata: {
      layout: {
        rows: [
          [
            'search',
            'location',
            'poiType',
            'poiVendor',
            'xcipioService',
            'cfType',
          ],
        ],
      },
    },
    fields: {
      search: {
        type: 'textSuggest',
        initial: '',
        placeholder: 'Search for Location, POIs, IDs and more...',
        className: 'network-topology-filter-form-fields-search',
        options: [],
      },
      location: {
        type: 'multiSelectCustom',
        initial: '',
        placeholder: 'Location',
        allowCreate: false,
        options: [],
      },
      poiType: {
        type: 'multiSelectCustom',
        initial: '',
        placeholder: 'POI Type',
        allowCreate: false,
        options: [],
      },
      poiVendor: {
        type: 'multiSelectCustom',
        initial: '',
        placeholder: 'POI Vendor',
        allowCreate: false,
        options: [],
      },
      xcipioService: {
        type: 'multiSelectCustom',
        initial: '',
        allowCreate: false,
        placeholder: 'Xcipio Service',
        options: [],
      },
      cfType: {
        type: 'multiSelectCustom',
        initial: '',
        allowCreate: false,
        placeholder: 'CF Type',
        options: [],
      },
      customFilter: {
        type: 'custom',
        customComponent: 'networkTopologyCustomFilters',
        className: 'network-topology-filter-form-custom',
      },
    },
  },
};
